export default {
  offeringAPI: {
    defaultValue: 'https://eu-offering-api.kambicdn.com/offering/v2018',
    server: 'https://eu-offering-api.kambicdn.com/offering/v2018'
  },
  playerAPI: {
    defaultValue: 'https://al-auth-api.kambi.com/player/api/v2019',
    brand: {
      ids: [58, 75, 76, 31],
      endpoint: 'https://cf-mt-auth-api.kambicdn.com/player/api/v2019'
    }
  },
  skdScript: 'https://c3-static.kambi.com/client',
  pushAPI: 'wss://eu-push.kambicdn.com',
  widgetsAPI: {
    url: 'https://static.kambicdn.com/client/widget-api'
  }
};
